import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Currency from "~/cabinet/vue/interface/Currency.vue";
import {useTarifPriceProps} from "~/cabinet/vue/dealer/config/uslugi/tarif/common/price/useTarifPrice";
import {PartPagerTarifPrice} from "~/cabinet/vue/dealer/config/uslugi/tarif/pager/PagerTarifPrice";


const __default__ = {
    name: "PagerPartPriceTableCell"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useTarifPriceProps<PartPagerTarifPrice>()
},
  setup(__props) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(Currency, {
      "currency-id": _unref(props).modelValue.currencyId,
      sum: _unref(props).modelValue.getPricesDictionary()['0'],
      "short-descr": ""
    }, null, 8, ["currency-id", "sum"]),
    _cache[0] || (_cache[0] = _createTextVNode(" → ", -1)),
    _createVNode(Currency, {
      "currency-id": _unref(props).modelValue.currencyId,
      sum: _unref(props).modelValue.getPricesDictionary()['n'],
      "short-descr": ""
    }, null, 8, ["currency-id", "sum"])
  ]))
}
}

})